import React, { ReactNode } from 'react';

type BadgeVariant = 'primary' | 'secondary' | 'success' | 'warning' | 'error' | 'gray';
type BadgeSize = 'sm' | 'md' | 'lg';

interface BadgeProps {
	children: ReactNode;
	variant?: BadgeVariant;
	size?: BadgeSize;
	icon?: ReactNode;
	className?: string;
}

const Badge: React.FC<BadgeProps> = ({
	children,
	variant = 'primary',
	size = 'md',
	icon,
	className = '',
}) => {
	// Base classes
	const baseClasses = 'inline-flex items-center justify-center rounded-full font-medium';

	// Size classes
	const sizeClasses = {
		sm: 'text-xs px-2 py-0.5',
		md: 'text-sm px-2.5 py-1',
		lg: 'text-base px-3 py-1.5',
	};

	// Variant classes
	const variantClasses = {
		primary: 'bg-white/10 text-primary',
		secondary: 'bg-secondary/10 text-secondary',
		success: 'bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400',
		warning: 'bg-yellow-100 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-400',
		error: 'bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-400',
		gray: 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300',
	};

	const classes = `${baseClasses} ${sizeClasses[size]} ${variantClasses[variant]} ${className}`;

	return (
		<span className={classes}>
			{icon && <span className="mr-1">{icon}</span>}
			{children}
		</span>
	);
};

export default Badge;